import { AnyExtension, Node } from '@tiptap/core';
import { InlineNodes, NodeGroup } from '../available-extensions';

/**
 * Schema-only twin of the Angular MentionAutocompleteNodeComponent — prevents TipTap
 * from dropping unregistered nodes during HTML serialisation (PDF generation).
 */
export const mentionAutocompleteSerialisation = Node.create({
  name: InlineNodes.MentionAutocomplete,
  content: `${InlineNodes.Text}*`,
  group: NodeGroup.Inline,
  inline: true,
  defining: true,

  addAttributes() {
    return {
      uid: { default: undefined },
    };
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },

  parseHTML() {
    return [];
  },
}) as AnyExtension;
